const r = {
  inline: !0,
  attrs: {
    uri: { default: "" },
    name: { default: "" }
  },
  group: "inline",
  selectable: !0,
  parseDOM: [
    {
      tag: "span.embercom-prosemirror-composer-mention",
      getAttrs(e) {
        return {
          name: e.innerText,
          uri: e.getAttribute("data-uri")
        };
      }
    }
  ],
  toDOM(e) {
    return [
      "span",
      { class: "embercom-prosemirror-composer-mention", "data-uri": e.attrs.uri },
      e.attrs.name
    ];
  }
};
export {
  r as mentionSpec
};
